<template>
  <footer class="app-footer">
    <PageContainer>
      <CarrotStack gap="4">
        <CarrotStack
          :orientation="{ base: 'vertical', md: 'horizontal' }"
          :align="{ base: 'center', md: 'start' }"
          :justify="{ md: 'space-between' }"
          :gap="{ base: '6', md: '4' }"
        >
          <CarrotStack gap="4" :align="{ base: 'center', md: 'start' }">
            <img :src="logoSrc" alt="Carrot" class="app-footer__logo-img" />
            <CarrotStack gap="1" :align="{ base: 'center', md: 'start' }">
              <CarrotText size="sm" class="app-footer__text">{{ COMPANY_NAME }}</CarrotText>
              <CarrotText size="sm" class="app-footer__text">Company No. {{ COMPANY_NUMBER }}</CarrotText>
              <CarrotText size="sm" class="app-footer__text">
                Registered in England and Wales
              </CarrotText>
              <a :href="`mailto:${COMPANY_EMAIL}`" class="app-footer__email">{{ COMPANY_EMAIL }}</a>
            </CarrotStack>
          </CarrotStack>

          <CarrotStack
            :orientation="{ base: 'column', md: 'horizontal' }"
            :align="{ base: 'center', md: 'start' }"
            gap="4"
            wrap
          >
            <router-link
              v-for="item in links"
              :key="item.to"
              :to="item.to"
              class="app-footer__link"
            >
              {{ item.label }}
            </router-link>
          </CarrotStack>
        </CarrotStack>

        <CarrotText size="xs" align="right" class="app-footer__text app-footer__copyright">
          © 2025–2026 {{ COMPANY_NAME }}.<br class="mobile-break" />
          All rights reserved.
        </CarrotText>
      </CarrotStack>
    </PageContainer>
  </footer>
</template>

<script setup lang="ts">
import PageContainer from "@/components/PageContainer.vue";
import logoSrc from "@/assets/logo/Logo-Orange.svg";
import { COMPANY_EMAIL, COMPANY_NAME, COMPANY_NUMBER } from "@/constants/company";
import { CarrotStack, CarrotText } from "@carrot/design-controls-vue";

const links = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/contact", label: "Contact" },
  { to: "/support", label: "Support" },
];
</script>

<style scoped>
@layer kapish.components {
  .app-footer {
    background: var(--color-secondary-dark);
    padding-block: var(--space-8, 2rem);
  }

  .app-footer__logo-img {
    height: 1.5rem;
    width: fit-content;
  }

  .app-footer__text {
    color: var(--color-carrot--on-blue);
  }

  .app-footer__copyright {
    text-align: center !important;
    @container (min-width: 768px) {
      text-align: right !important;
    }
  }

  .app-footer__link {
    color: var(--color-carrot--on-blue);
    text-decoration: none;
    font-size: var(--font-size-sm, 0.875rem);
  }

  /* Sits with the registered details rather than the nav links: it is a
   * trading disclosure (Electronic Commerce Regulations 2002), not a
   * navigation item. Underlined so it reads as the actionable one of the
   * four lines in that block. */
  .app-footer__email {
    color: var(--color-carrot--on-blue);
    font-size: var(--font-size-sm, 0.875rem);
    text-decoration: underline;
  }

  .app-footer__link:hover {
    text-decoration: underline;
  }
}
</style>
